/**
 * useNoIndex — adds <meta name="robots" content="noindex,nofollow"> to the
 * document head while the calling page is mounted (PR #33, R8).
 *
 * Cloudflare Pages serves all our routes without robots.txt restrictions,
 * so by default Google would happily index private surfaces like
 * /sign/{token} and /admin. This hook stops that for those pages.
 *
 * Usage:
 *   import { useNoIndex } from "@/lib/useNoIndex";
 *   useNoIndex();  // top of any component that should NOT be indexed
 */
import { useEffect } from "react";

export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => {
      try { document.head.removeChild(meta); } catch (_) { /* already gone */ }
    };
  }, []);
}
